(() => {
  if (customElements.get('lig-home-hero')) return;
  class HomeHero extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.slides = [...this.querySelectorAll('[data-hero-slide]')];
      if (this.slides.length < 2) return;
      this.index = 0;
      this.abort = new AbortController();
      const on = (target, event, fn, options = {}) => target.addEventListener(event, fn, { ...options, signal: this.abort.signal });
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.reduced.matches;
      this.dots = [...this.querySelectorAll('[data-hero-go]')];
      this.pause = this.querySelector('[data-hero-pause]');
      this.querySelector('.lig-homehero__controls').hidden = false;
      this.dots.forEach((dot, index) => on(dot, 'click', () => this.go(index, true)));
      on(this.querySelector('[data-hero-next]'), 'click', () => this.go(this.index + 1, true));
      on(this.querySelector('[data-hero-prev]'), 'click', () => this.go(this.index - 1, true));
      on(this.pause, 'click', () => { this.paused = !this.paused; this.sync(); });
      on(this, 'pointerenter', e => { if (e.pointerType === 'mouse') { this.hovered = true; this.sync(); } });
      on(this, 'pointerleave', () => { this.hovered = false; this.sync(); });
      on(this, 'focusin', e => { if (e.target !== this.pause) { this.paused = true; this.sync(); } });
      on(this, 'keydown', e => {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault(); this.go(this.index + (e.key === 'ArrowRight' ? 1 : -1), true);
      });
      on(document, 'visibilitychange', () => this.sync());
      on(this.reduced, 'change', () => { if (this.reduced.matches) this.paused = true; this.sync(); });
      on(document, 'shopify:block:select', e => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === e.detail?.blockId);
        if (index >= 0) this.go(index, true);
      });
      let touch;
      on(this, 'touchstart', e => { touch = e.touches[0] && { x: e.touches[0].clientX, y: e.touches[0].clientY }; }, { passive: true });
      on(this, 'touchend', e => {
        const end = e.changedTouches[0];
        if (!touch || !end || e.target.closest('a,button')) return;
        const dx = end.clientX - touch.x, dy = end.clientY - touch.y;
        if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.4) this.go(this.index + (dx < 0 ? 1 : -1), true);
        touch = null;
      }, { passive: true });
      this.observer = new IntersectionObserver(entries => { this.offscreen = !entries[0].isIntersecting; this.sync(); }, { threshold: .15 });
      this.observer.observe(this);
      this.sync();
    }
    go(index, manual = false) {
      if (manual) this.paused = true;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.classList.toggle('is-active', active);
        slide.inert = !active;
        if (active) slide.removeAttribute('aria-hidden'); else slide.setAttribute('aria-hidden', 'true');
        if (active) slide.querySelectorAll('img').forEach(img => { img.loading = 'eager'; });
        if (active) this.dots[i].setAttribute('aria-current', 'true'); else this.dots[i].removeAttribute('aria-current');
        this.dots[i].classList.toggle('is-active', active);
      });
      if (manual) this.querySelector('.lig-homehero__status').textContent = this.slides[this.index].getAttribute('aria-label');
      this.sync();
    }
    sync() {
      clearTimeout(this.timer);
      this.pause.setAttribute('aria-label', this.paused ? 'Play featured collections' : 'Pause featured collections');
      this.pause.querySelector('[data-pause-symbol]').textContent = this.paused ? '▷' : 'Ⅱ';
      if (!this.paused && !this.hovered && !this.offscreen && !document.hidden) this.timer = setTimeout(() => this.go(this.index + 1), Math.max(5000, Number(this.dataset.interval) || 9000));
    }
    disconnectedCallback() { clearTimeout(this.timer); this.observer?.disconnect(); this.abort?.abort(); this.bound = false; }
  }
  customElements.define('lig-home-hero', HomeHero);
})();
